import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import ProductPrice from '@components/ProductItemPrice';
import { PRODUCT_CLICK_LOCATION } from '@conversion/constants';

const Container = styled.div`
  display: inline-block;
  padding-top: ${({ theme }) => theme.shopdetails.productCard.price.paddingTop};
  line-height: 1.25;
`;

function Price({
  price,
  priceWithDiscount,
  subsidizedProduct,
  discount,
  finalPriceWithoutTaxes,
}) {
  const priceElement = (
    <Container id={PRODUCT_CLICK_LOCATION.PRICE}>
      <ProductPrice
        price={price}
        priceWithDiscount={priceWithDiscount}
        subsidizedProduct={subsidizedProduct}
        discount={discount}
        finalPriceWithoutTaxes={finalPriceWithoutTaxes}
      />
    </Container>
  );

  return priceElement;
}

Price.propTypes = {
  price: PropTypes.number.isRequired,
  finalPriceWithoutTaxes: PropTypes.number,
  priceWithDiscount: PropTypes.number,
  subsidizedProduct: PropTypes.object,
  discount: PropTypes.bool,
};

export default Price;
